var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009b58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0092a1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_168909",
    "data-name": "Group 168909",
    transform: "translate(-157 -271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83179",
    "data-name": "Path 83179",
    d: "M40,0C71.046,0,80,8.954,80,40S71.046,80,40,80,0,71.046,0,40,8.954,0,40,0Z",
    transform: "translate(157 271)",
    fill: "#f2f3f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_168908",
    "data-name": "Group 168908",
    transform: "translate(3310 -1841.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83382",
    "data-name": "Path 83382",
    d: "M25.875,1.314l-9.56,9.513a4.489,4.489,0,0,0,0,6.35,4.54,4.54,0,0,0,6.381,0l1.853-1.843V31.028a4.511,4.511,0,0,0,9.023,0L33.567,4.5a4.511,4.511,0,0,0-7.691-3.181",
    transform: "translate(-3126.572 2134.137)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83381",
    "data-name": "Path 83381",
    d: "M0,4.5a4.512,4.512,0,0,1,7.7-3.18l9.558,9.511a4.488,4.488,0,0,1,0,6.351,4.542,4.542,0,0,1-6.381,0L9.024,15.337V31.029a4.512,4.512,0,0,1-9.024,0Z",
    transform: "translate(-3133 2134.137)",
    fill: "#fabf00",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMb);
export default __webpack_public_path__ + "static/media/mb.c1c25ea28f29d7918469c6f49581d851.svg";
export { ForwardRef as ReactComponent };